function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 13.59375 4 L 13.28125 4.28125 L 12.5625 5 L 6 5 L 6 7 L 7 7 L 7 25 C 7 26.645455 8.3545455 28 10 28 L 22 28 C 23.645455 28 25 26.645455 25 25 L 25 7 L 26 7 L 26 5 L 19.4375 5 L 18.71875 4.28125 L 18.40625 4 L 18 4 L 14 4 L 13.59375 4 z M 14.4375 6 L 17.5625 6 L 18.28125 6.71875 L 18.59375 7 L 19 7 L 23 7 L 23 25 C 23 25.554545 22.554545 26 22 26 L 10 26 C 9.4454545 26 9 25.554545 9 25 L 9 7 L 13 7 L 13.40625 7 L 13.71875 6.71875 L 14.4375 6 z M 11 11 L 11 22 L 13 22 L 13 11 L 11 11 z M 15 11 L 15 22 L 17 22 L 17 11 L 15 11 z M 19 11 L 19 22 L 21 22 L 21 11 L 19 11 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Bitstream Vera Sans"
  }));
};

export default __webpack_public_path__ + "static/media/remove.82ab56d3.svg";
export { SvgComponent as ReactComponent };